const compareArrays = (arr1, arr2) => {
  const diffObj = arr1.find(
    obj1 => !arr2?.some(obj2 => JSON.stringify(obj1) === JSON.stringify(obj2))
  );
  return diffObj;
};

export default compareArrays;
